import HmacSimulatorLayout from "./hmac_simulator_layout";

const HmacSimulatorPage = () => {
  return (
      <HmacSimulatorLayout />
  );
};

export default HmacSimulatorPage;